// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file catalogos_pesaje.proto (package sextante.catalogos.pesaje.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalogos_pesaje.proto.
 */
export const file_catalogos_pesaje: GenFile = /*@__PURE__*/
  fileDesc("ChZjYXRhbG9nb3NfcGVzYWplLnByb3RvEhxzZXh0YW50ZS5jYXRhbG9nb3MucGVzYWplLnYxIj8KDlRpcG9BbmltYWxJdGVtEgoKAmlkGAEgASgJEhEKCWVsaW1pbmFkbxgCIAEoCBIOCgZub21icmUYBCABKAkiOAoXTGlzdFRpcG9BbmltYWxlc1JlcXVlc3QSHQoVdWx0aW1hX3NpbmNyb25pemFjaW9uGAEgASgDInkKGExpc3RUaXBvQW5pbWFsZXNSZXNwb25zZRI7CgVpdGVtcxgBIAMoCzIsLnNleHRhbnRlLmNhdGFsb2dvcy5wZXNhamUudjEuVGlwb0FuaW1hbEl0ZW0SIAoYdGltZXN0YW1wX3NpbmNyb25pemFjaW9uGAIgASgDIk4KDlJhemFBbmltYWxJdGVtEgoKAmlkGAEgASgJEhEKCWVsaW1pbmFkbxgCIAEoCBIPCgd0aXBvX2lkGAQgASgJEgwKBHJhemEYBiABKAkiOAoXTGlzdFJhemFBbmltYWxlc1JlcXVlc3QSHQoVdWx0aW1hX3NpbmNyb25pemFjaW9uGAEgASgDInkKGExpc3RSYXphQW5pbWFsZXNSZXNwb25zZRI7CgVpdGVtcxgBIAMoCzIsLnNleHRhbnRlLmNhdGFsb2dvcy5wZXNhamUudjEuUmF6YUFuaW1hbEl0ZW0SIAoYdGltZXN0YW1wX3NpbmNyb25pemFjaW9uGAIgASgDImsKHFByb2NlZGltaWVudG9WZXRlcmluYXJpb0l0ZW0SCgoCaWQYASABKAkSEQoJZWxpbWluYWRvGAIgASgIEg4KBm5vbWJyZRgEIAEoCRIMCgRtZXRhGAUgASgJEg4KBmlzX2ljYRgGIAEoCCJFCiRMaXN0UHJvY2VkaW1pZW50b1ZldGVyaW5hcmlvc1JlcXVlc3QSHQoVdWx0aW1hX3NpbmNyb25pemFjaW9uGAEgASgDIpQBCiVMaXN0UHJvY2VkaW1pZW50b1ZldGVyaW5hcmlvc1Jlc3BvbnNlEkkKBWl0ZW1zGAEgAygLMjouc2V4dGFudGUuY2F0YWxvZ29zLnBlc2FqZS52MS5Qcm9jZWRpbWllbnRvVmV0ZXJpbmFyaW9JdGVtEiAKGHRpbWVzdGFtcF9zaW5jcm9uaXphY2lvbhgCIAEoAzLLAwoWQ2F0YWxvZ29zUGVzYWplU2VydmljZRKBAQoQTGlzdFRpcG9BbmltYWxlcxI1LnNleHRhbnRlLmNhdGFsb2dvcy5wZXNhamUudjEuTGlzdFRpcG9BbmltYWxlc1JlcXVlc3QaNi5zZXh0YW50ZS5jYXRhbG9nb3MucGVzYWplLnYxLkxpc3RUaXBvQW5pbWFsZXNSZXNwb25zZRKBAQoQTGlzdFJhemFBbmltYWxlcxI1LnNleHRhbnRlLmNhdGFsb2dvcy5wZXNhamUudjEuTGlzdFJhemFBbmltYWxlc1JlcXVlc3QaNi5zZXh0YW50ZS5jYXRhbG9nb3MucGVzYWplLnYxLkxpc3RSYXphQW5pbWFsZXNSZXNwb25zZRKoAQodTGlzdFByb2NlZGltaWVudG9WZXRlcmluYXJpb3MSQi5zZXh0YW50ZS5jYXRhbG9nb3MucGVzYWplLnYxLkxpc3RQcm9jZWRpbWllbnRvVmV0ZXJpbmFyaW9zUmVxdWVzdBpDLnNleHRhbnRlLmNhdGFsb2dvcy5wZXNhamUudjEuTGlzdFByb2NlZGltaWVudG9WZXRlcmluYXJpb3NSZXNwb25zZUILqgIIQXBpLkdycGNiBnByb3RvMw");

/**
 * Tipo de animal del catalogo.
 *
 * @generated from message sextante.catalogos.pesaje.v1.TipoAnimalItem
 */
export type TipoAnimalItem = Message<"sextante.catalogos.pesaje.v1.TipoAnimalItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.TipoAnimalItem.
 * Use `create(TipoAnimalItemSchema)` to create a new message.
 */
export const TipoAnimalItemSchema: GenMessage<TipoAnimalItem> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 0);

/**
 * Pedido del catalogo de tipos de animal.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListTipoAnimalesRequest
 */
export type ListTipoAnimalesRequest = Message<"sextante.catalogos.pesaje.v1.ListTipoAnimalesRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListTipoAnimalesRequest.
 * Use `create(ListTipoAnimalesRequestSchema)` to create a new message.
 */
export const ListTipoAnimalesRequestSchema: GenMessage<ListTipoAnimalesRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 1);

/**
 * Tipos de animal que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListTipoAnimalesResponse
 */
export type ListTipoAnimalesResponse = Message<"sextante.catalogos.pesaje.v1.ListTipoAnimalesResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.pesaje.v1.TipoAnimalItem items = 1;
   */
  items: TipoAnimalItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListTipoAnimalesResponse.
 * Use `create(ListTipoAnimalesResponseSchema)` to create a new message.
 */
export const ListTipoAnimalesResponseSchema: GenMessage<ListTipoAnimalesResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 2);

/**
 * Raza del catalogo, con el tipo de animal al que pertenece.
 *
 * @generated from message sextante.catalogos.pesaje.v1.RazaAnimalItem
 */
export type RazaAnimalItem = Message<"sextante.catalogos.pesaje.v1.RazaAnimalItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Tipo de animal de la raza.
   *
   * @generated from field: string tipo_id = 4;
   */
  tipoId: string;

  /**
   * @generated from field: string raza = 6;
   */
  raza: string;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.RazaAnimalItem.
 * Use `create(RazaAnimalItemSchema)` to create a new message.
 */
export const RazaAnimalItemSchema: GenMessage<RazaAnimalItem> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 3);

/**
 * Pedido del catalogo de razas.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListRazaAnimalesRequest
 */
export type ListRazaAnimalesRequest = Message<"sextante.catalogos.pesaje.v1.ListRazaAnimalesRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListRazaAnimalesRequest.
 * Use `create(ListRazaAnimalesRequestSchema)` to create a new message.
 */
export const ListRazaAnimalesRequestSchema: GenMessage<ListRazaAnimalesRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 4);

/**
 * Razas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListRazaAnimalesResponse
 */
export type ListRazaAnimalesResponse = Message<"sextante.catalogos.pesaje.v1.ListRazaAnimalesResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.pesaje.v1.RazaAnimalItem items = 1;
   */
  items: RazaAnimalItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListRazaAnimalesResponse.
 * Use `create(ListRazaAnimalesResponseSchema)` to create a new message.
 */
export const ListRazaAnimalesResponseSchema: GenMessage<ListRazaAnimalesResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 5);

/**
 * Procedimiento veterinario del catalogo.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ProcedimientoVeterinarioItem
 */
export type ProcedimientoVeterinarioItem = Message<"sextante.catalogos.pesaje.v1.ProcedimientoVeterinarioItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: string nombre = 4;
   */
  nombre: string;

  /**
   * Descripcion corta o indicacion, por ejemplo Ciclo obligatorio ICA.
   *
   * @generated from field: string meta = 5;
   */
  meta: string;

  /**
   * Procedimiento exigido por el ICA.
   *
   * @generated from field: bool is_ica = 6;
   */
  isIca: boolean;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ProcedimientoVeterinarioItem.
 * Use `create(ProcedimientoVeterinarioItemSchema)` to create a new message.
 */
export const ProcedimientoVeterinarioItemSchema: GenMessage<ProcedimientoVeterinarioItem> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 6);

/**
 * Pedido del catalogo de procedimientos veterinarios.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosRequest
 */
export type ListProcedimientoVeterinariosRequest = Message<"sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosRequest.
 * Use `create(ListProcedimientoVeterinariosRequestSchema)` to create a new message.
 */
export const ListProcedimientoVeterinariosRequestSchema: GenMessage<ListProcedimientoVeterinariosRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 7);

/**
 * Procedimientos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosResponse
 */
export type ListProcedimientoVeterinariosResponse = Message<"sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.pesaje.v1.ProcedimientoVeterinarioItem items = 1;
   */
  items: ProcedimientoVeterinarioItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.pesaje.v1.ListProcedimientoVeterinariosResponse.
 * Use `create(ListProcedimientoVeterinariosResponseSchema)` to create a new message.
 */
export const ListProcedimientoVeterinariosResponseSchema: GenMessage<ListProcedimientoVeterinariosResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_pesaje, 8);

/**
 * Migracion a gRPC-Web de los catalogos de TipoAnimal/RazaAnimal/ProcedimientoVeterinario (ver
 * CLAUDE.md, seccion migracion a gRPC-Web). Mismo criterio de delta que catalogos_aplicaciones.proto
 * (incluido no exponer "ultima_actualizacion" -ver ese archivo-).
 *
 * @generated from service sextante.catalogos.pesaje.v1.CatalogosPesajeService
 */
export const CatalogosPesajeService: GenService<{
  /**
   * Catalogo de tipos de animal, por delta.
   *
   * @generated from rpc sextante.catalogos.pesaje.v1.CatalogosPesajeService.ListTipoAnimales
   */
  listTipoAnimales: {
    methodKind: "unary";
    input: typeof ListTipoAnimalesRequestSchema;
    output: typeof ListTipoAnimalesResponseSchema;
  },
  /**
   * Catalogo de razas, por delta.
   *
   * @generated from rpc sextante.catalogos.pesaje.v1.CatalogosPesajeService.ListRazaAnimales
   */
  listRazaAnimales: {
    methodKind: "unary";
    input: typeof ListRazaAnimalesRequestSchema;
    output: typeof ListRazaAnimalesResponseSchema;
  },
  /**
   * Catalogo de procedimientos veterinarios, por delta.
   *
   * @generated from rpc sextante.catalogos.pesaje.v1.CatalogosPesajeService.ListProcedimientoVeterinarios
   */
  listProcedimientoVeterinarios: {
    methodKind: "unary";
    input: typeof ListProcedimientoVeterinariosRequestSchema;
    output: typeof ListProcedimientoVeterinariosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalogos_pesaje, 0);

